export const ebay = {
  oAuthFlowHelp: "Authorize ebay",
  authSuccess: "Authentication successful",
  migrationSuccess: "Successfully retrieved token from eBay.",
  accountNotice:
    "Please make sure you are logged in to the correct eBay account before authorizing. Every integration needs its own eBay account – if you reuse an account that is already connected to another integration, the data of both integrations will get mixed up. If you are unsure which account is active, log out of eBay first."
};
